export default __webpack_public_path__ + "static/media/batu.8105c110.mp3";